import React, { useRef } from "react";
import PropTypes from "prop-types";
import ReviewStars from "components/source/shared/review-stars";

const HappinessSurveyRating = ({ value = 0, onChange, onClick }) => {
  const containerRef = useRef(null);

  const handleClick = e => {
    const el = containerRef.current;
    if (!el) return;

    const { left, width } = el.getBoundingClientRect();
    const clickX = e.clientX - left;
    const starIndex = Math.min(4, Math.floor((clickX / width) * 5));
    const newRating = starIndex + 1;

    onChange?.(newRating);
    onClick?.(newRating);
  };

  const starImage = {
    0: "BlackStars0",
    1: "BlackStars2",
    2: "BlackStars4",
    3: "BlackStars6",
    4: "BlackStars8",
    5: "BlackStars10",
  };
  const ratingImage = starImage[value] ?? "BlackStars0";

  return (
    <div
      ref={containerRef}
      onClick={handleClick}
      className="cursor-pointer w-max"
      data-test-id="happiness-survey-rating"
      role="button"
      tabIndex={0}
      aria-label={`Rate ${value} out of 5`}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") handleClick(e);
        if (e.key === "ArrowLeft" || e.key === "ArrowDown") onChange?.(Math.max(1, value - 1));
        if (e.key === "ArrowRight" || e.key === "ArrowUp") onChange?.(Math.min(5, value + 1));
      }}>
      <ReviewStars imageName={ratingImage} />
    </div>
  );
};

HappinessSurveyRating.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

export default HappinessSurveyRating;
